import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

export const usePageTitle = (title: string) => {
  const { gym } = useAuth();
  
  useEffect(() => {
    const gymName = gym ? gym.name : 'Central Core+';
    document.title = `${gymName} - ${title}`;
    
    return () => {
      document.title = 'Central Core+ Admin';
    };
  }, [title, gym]);
}; 